<app-loading [show]="isLoading"></app-loading>
<!-- <app-nav-bar class="header_cnt"></app-nav-bar> -->
<section class="row">
  <section class="col-12 p-0">
    <article class="main_cnt">
      <router-outlet></router-outlet>
    </article>
  </section>
</section>
